import { SpecialOfferProps } from '../types';
import {
  Product,
  ProductsBackground,
  StyledFrame,
  StyledSpecialOffer,
} from './style';
import BundlePrice from '../../Bundles/BundlePrice';
import { EBundlesInternalViewModel } from 'utils/enums';
import { Box } from '@mui/system';
import { BagelcodeSaleBadge } from 'components/Badge/Sale/BagelcodeSaleBadge';

export const BagelCodeSpecialOffer: React.FC<SpecialOfferProps> = ({
  price,
  productsList,
  availability,
  backgroundColor,
  backgroundImage,
  selectOffer,
  salePercentage = 0,
  salePercentageDisplayType,
  isFree,
  collectText,
  availabilityText,
  timer
}) => {
  return (
    <StyledFrame onClick={selectOffer}>
      <StyledSpecialOffer
        backgroundColor={backgroundColor}
        backgroundImage={backgroundImage}
      >
        <div className="frame">
          {salePercentage > 0 && (
            <BagelcodeSaleBadge
              salePercentage={salePercentage}
              salePercentageDisplayType={salePercentageDisplayType}
            />
          )}
          <div className="products__container">
            <ProductsBackground>
              {productsList.map((product) => {
                return (
                  <Product key={product.name} data={product}>
                    <div className="image-container">
                      <img
                        src={product.images.product}
                        alt="product"
                        className="image"
                      />
                    </div>
                    <span
                      style={{
                        textAlign: product.suffix ? 'center' : 'left',
                      }}
                    >
                      {product.quantityDisplay}
                    </span>
                    {salePercentage > 0 && (
                      <p className="stroked">{product.strokedSaleQuantity}</p>
                    )}
                  </Product>
                );
              })}
            </ProductsBackground>
          </div>
          <Box className="price-container">
            <BundlePrice
              price={price}
              type={EBundlesInternalViewModel.BAGLECODE}
              availabilityText={availabilityText}
              availability={availability}
              isFree={isFree}
              buttonText={collectText}
              timer={timer}
            />
          </Box>
        </div>
      </StyledSpecialOffer>
    </StyledFrame>
  );
};
